import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import AddLeaveCredebility from './sections/add.jsx';
import EditLeaveCredebility from './sections/edit.jsx';
import ExcelExport from './sections/export.jsx';

const LeavesCredebility = () => {
    const [data, setData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [Id, setId] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filterEmp, setFilterEmp] = useState('');

    const fetchData = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves_credebility?page=${currentPage + 1}`)
            .then(response => {
                setData(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching leave credebilities!", error);
                setData([]);
            });

        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves_credebility/create`)
            .then(response => {
                setUserData(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching leave credebilities!", error);
                setUserData([]);
            });
    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = data.filter((item) => {
        const matchesLeaveType = item.leave_type.toLowerCase().includes(filterText.toLowerCase());
        return matchesLeaveType;
    });

    // Search input handler
    const filteredEmpData = userData.filter((item) => {
        const matchesEmp = item.employee_name.toLowerCase().includes(filterEmp.toLowerCase());
        return matchesEmp;
    });

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Leaves Credebility</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Leaves Credebility</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave_cred">
                                <i className="fa-solid fa-plus"></i> Add Leave Credebility</Link>
                        </div>
                    </div>
                </div>

                <div className="card mt-2">
                    <div className="card-body">
                        <ul className="nav nav-pills nav-style-2 mb-3 border-bottom" role="tablist">
                            <li className="nav-item" role="presentation">
                                <Link className="nav-link active" data-bs-toggle="tab" role="tab" aria-current="page" to="#credebility"
                                    aria-selected="true">Leave Credebility</Link>
                            </li>
                            <li className="nav-item" role="presentation">
                                <Link className="nav-link" data-bs-toggle="tab" role="tab" aria-current="page" to="#employeeRecords"
                                    aria-selected="false" tabIndex="-1">Current Employees Leave Records</Link>
                            </li>
                        </ul>

                        <div className="tab-content">
                            <div id="credebility" className="tab-pane text-muted active show" role="tabpanel">
                                <div className="row">
                                    <div className="col-md-3 mb-4">
                                        <input className="form-control" type="text" placeholder="Search leave type..." aria-label="Search Input"
                                            value={filterText} onChange={(event)=>{setFilterText(event.target.value)}} />
                                    </div>
                                </div>
                                
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Leave Type</th>
                                                <th>Total Annual Leaves (In Days)</th>
                                                <th>Total Annual Leaves (In Hours)</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((row) => (
                                                        <tr key={row.id}>
                                                            <td>{row.leave_type}</td>
                                                            <td>{row.total_annual_leaves} Days</td>
                                                            <td>{row.total_annual_leaves * 8} Hours</td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setId(`${row.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_leave_cred_${row.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">No records found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
                            </div>

                            <div id="employeeRecords" className="tab-pane text-muted" role="tabpanel">
                                <div className="row">
                                    <div className="col-md-3 mb-4">
                                        <input className="form-control" type="text" placeholder="Search employee..." aria-label="Search Input"
                                            value={filterEmp} onChange={(event)=>{setFilterEmp(event.target.value)}} />
                                    </div>
                                    <div className="col-md-9" align="right">
                                        <ExcelExport data={filteredEmpData} fileName="EmployeeLeaveCredebilities" />
                                    </div>
                                </div>

                                <div className="attendance-list">
                                    <div className="row">
                                        {
                                            filteredEmpData.length > 0 && (
                                                filteredEmpData.map((row, index) => (
                                                    <div className="col-md-3" key={index}>
                                                        <div className="card bg-light border border-secondary rounded p-3">
                                                            <h4 className="mb-2">{row.employee_name}</h4>
                                                            <div className="row">
                                                                {
                                                                    row.leaveData.length > 0 && (
                                                                        row.leaveData.map((cred, index) => (
                                                                            <div className="col-md-6" style={{fontSize:'14px'}}>
                                                                                <div className="attendance-details" key={index}>
                                                                                    <h5 className="text-primary mb-1">{cred.leave_type}</h5>
                                                                                    <small>Total Leaves: <span  className="text-success">{cred.total_leaves} Hrs.</span></small><br />
                                                                                    <small>Used Leaves: <span  className="text-danger">{cred.used_leaves} Hrs.</span></small><br />
                                                                                    <small>Remaining Leaves: <span  className="text-info">{cred.total_leaves-cred.used_leaves} Hrs.</span></small><br />
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddLeaveCredebility list={fetchData}/>
            <EditLeaveCredebility list={fetchData} Id={Id} />
        </>
    );
}

export default LeavesCredebility